import React, { type SelectHTMLAttributes } from 'react';

import { StyledSelect } from '@pkg/components/Sections/Admin/components/Form/styles';

type DropdownProps = SelectHTMLAttributes<HTMLSelectElement> & {
    compact?: boolean;
};

export const Dropdown = ({ compact = false, ...props }: DropdownProps) => {
    return <StyledSelect $compact={compact} {...props} />;
};
